import { createIcon } from '../icon'
import SearchIconNew from '../svg/SearchIconNew'

export const SearchIconNewDefault = createIcon(SearchIconNew)
